
const apiKey = "AIzaSyBU57rKc9HVMOYyYFDHI0Cn0q2lAINzRkc";

export const googleTranslate = require("google-translate")(apiKey);